import { useRef, useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import { setCredentials, setCompany, selectCurrentToken, selectCurrentUser, setUserInfo, setPermissions, logOut } from './authSlice'
import { useLazyCheckTokenQuery, useLazyGetInfoQuery, useLazyGetPermissionsQuery, useLoginMutation } from './authApiSlice'

import Loading from 'components/commons/Loading'
import { useTranslation } from 'react-i18next'
import { setSessionExpiry } from './sessionSlice'
import { useLazyGetMainSettingsQuery } from 'features/core/settings/api/mainSettingsApiSlice'

const Login = () => {
    const [t, i18n] = useTranslation(["global"])
    const userRef = useRef()
    const errRef = useRef()
    const [user, setUser] = useState('')
    const [pwd, setPwd] = useState('')
    const [storeSession, setStoreSession] = useState(false)
    const [errMsg, setErrMsg] = useState('')
    const navigate = useNavigate()

    const [login, { isLoading: isLoadingLogin }] = useLoginMutation()
    const [getInfoAboutMe, { isLoading: isLoadingInfo }] = useLazyGetInfoQuery()
    const [getPermissions, { isLoading: permissionsIsLoading }] = useLazyGetPermissionsQuery()
    // const [getSettings, { isLoading: settingsIsLoading }] = useLazyGetMainSettingsQuery()
    const [checkToken, { isLoading: tokenCheckIsLoading }] = useLazyCheckTokenQuery()
    const dispatch = useDispatch()

    const [isLoading, setLoading] = useState(false)

    useEffect(() => {
        userRef.current.focus()
        checkStoredSession()
    }, [])

    useEffect(() => {
        setErrMsg('')
    }, [user, pwd])

    const currentToken = useSelector(selectCurrentToken)
    const currentUser = useSelector(selectCurrentUser)


    // const startSessionTimer = (sessionDuration) => {
    //     const expiryTime = Date.now() + sessionDuration * 1000;
    //     dispatch(setSessionExpiry(expiryTime));

    //     setTimeout(() => {
    //         dispatch(logOut());
    //         alert(t("Session expired. Please log in again."));
    //         navigate('/login');
    //     }, sessionDuration * 1000);
    // };

    const checkStoredSession = async (e) => {

        let storedToken = localStorage.getItem("authToken")
        if (storedToken == null) return

        doAuthentication(true, async () => {
            // Authentication
            dispatch(setCredentials({ token: storedToken }))
            const claims = await checkToken().unwrap()
            dispatch(setCredentials({ claims: claims, user: claims.sub, token: storedToken }))
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        doAuthentication(false, async () => {
            // Authentication
            const userData = await login({ username: user, password: pwd }).unwrap()
            console.log(userData.token)
            dispatch(setCredentials({ ...userData, user, store: storeSession }))
        })
    }

    const doAuthentication = async (isStoredToken = false, auth = async () => { }) => {
        try {
            setLoading(true)
            await auth()
            // Retriving Session Info
            const userInfo = await getInfoAboutMe().unwrap()
            console.log("Selecting company:" + userInfo.employments[0].company.name)
            dispatch(setCompany(userInfo.employments[0].company))
            dispatch(setUserInfo(userInfo.user))

            // Dopo l'autenticazione, imposta la durata della sessione
            // const settings = await getSettings().unwrap()
            // const sessionDuration = settings.session_duration * 60; // Durata in secondi
            // const expiryTime = Date.now() + sessionDuration * 1000;
            // dispatch(setSessionExpiry(expiryTime)); // Aggiorna Redux con l'orario di scadenza
            // console.log("Timer di sessione impostato!")

            // Retriving Permissions
            const permissions = await getPermissions().unwrap()
            dispatch(setPermissions(permissions))
            console.log("Stored " + permissions.length + " permissions")

            // All ok, clean view and go to Dashboard...
            setLoading(false)
            setUser('')
            setPwd('')
            navigate('/dashboard/home')
        } catch (err) {
            setLoading(false)
            console.log(err)

            if (isStoredToken) {
                dispatch(logOut())
                return
            }
            if (!err?.status) {
                // isLoading: true until timeout occurs
                setErrMsg('No Server Response');
            } else if (err.status === 400) {
                setErrMsg('Missing Username or Password');
            } else if (err.status === 401) {
                setErrMsg('Unauthorized');
            } else if (err.status === 402) {
                setErrMsg('Licens Expired');
                navigate('/dashboard/license')
                return
            } else {
                setErrMsg('Login Failed');
            }
            errRef.current.focus();
        }

    }

    const handleUserInput = (e) => setUser(e.target.value)

    const handlePwdInput = (e) => setPwd(e.target.value)

    const handleStoreSessionInput = (e) => setStoreSession(e.target.checked)

    const content = (

        <div className="row justify-content-center">
            <div className="col-lg-5">
                <div className="card bg-dark shadow-lg border-0 rounded-lg mt-5">


                    <div className='text-center p-4'>
                        <img width="320px" src="/effihand_logo.png" />

                    </div>

                    <div className="card-header"><h4 className="text-center font-weight-light my-2">Login</h4></div>
                    <div className="card-body" ref={errRef}>
                        {
                            isLoading ? <Loading /> :
                                <>
                                    <p className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>

                                    <form onSubmit={handleSubmit} >
                                        <div className="form-floating mb-3">

                                            <input
                                                className="form-control"
                                                type="text"
                                                id="username"
                                                placeholder="name@example.com"
                                                ref={userRef}
                                                value={user}
                                                onChange={handleUserInput}
                                                autoComplete="off"
                                                required
                                            />
                                            <label htmlFor="username">Username / Email</label>
                                        </div>
                                        <div className="form-floating mb-3">

                                            <input
                                                className="form-control"
                                                type="password"
                                                id="password"
                                                placeholder="name@example.com"
                                                onChange={handlePwdInput}
                                                value={pwd}
                                                autoComplete="off"
                                                required
                                            />
                                            <label htmlFor="password">Password</label>
                                        </div>

                                        <div className="form-check mb-3">
                                            <input className="form-check-input" id="inputRememberPassword" type="checkbox" value="" onChange={(e) => { handleStoreSessionInput(e) }} />
                                            <label className="form-check-label" htmlFor="inputRememberPassword" >{t("helper.remember_session")}</label>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-between mt-4 mb-0">
                                            <Link to="/restore-password" className="small">{t("helper.forgot_password")}</Link>
                                            <button className="btn btn-primary">{t("action.login")}</button>
                                        </div>
                                    </form>
                                </>
                        }


                    </div>

                </div>
            </div>
        </div>



    )

    return content
}
export default Login